import { TextFilterProps } from '@progress/kendo-react-data-tools'

import { ClientSubscriptionLevel } from '../../api/Clients/Types/ClientSubscriptionType'
import { SelectFilter } from '../Filter/SelectFilter'

export const SelectSubscriptionLevelFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props

  const data = ClientSubscriptionLevel.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
